import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const root = css`
  text-decoration: none;
  font-weight: 500;
`

export const underlines = {
  none: css`
    text-decoration: none;
  `,
  hover: css`
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  `,
  always: css`
    text-decoration: underline;
  `,
}

export const colors = {
  default: (theme: Theme) => css`
    color: ${theme.palette.primary.mainContrast};
  `,
  main: (theme: Theme) => css`
    color: ${theme.palette.text.title};
  `,
  light: (theme: Theme) => css`
    color: ${theme.palette.tertiary.mediumContrastAlternative};
  `,
}

export const hovers = {
  primary: (theme: Theme) => css`
    &:hover {
      color: ${theme.palette.primary.maxContrast};
    }
  `,
  none: () => css``,
}

export const variants = {
  primary: (theme: Theme) => css`
    color: ${theme.palette.primary.mainContrast};
  `,
  secondary: (theme: Theme) => css`
    color: ${theme.palette.tertiary.mediumContrastAlternative};
  `,
  neutral: (theme: Theme) => css`
    color: ${theme.palette.text.title};
  `,
  none: () => css``,
}
